
<form class="custom-slider-container" >
  


    <input *ngIf="fromTooltipValue || fromTooltipValue === 0" type="text" pattern="[0-9]+[kmbKMB]{1}" autofocus [style.left]="fromTooltipPosition" [value]="fromTooltipValue" (blur)="updateSlider($event, 'from');">
    <input *ngIf="toTooltipValue || toTooltipValue === 0" type="text" pattern="[0-9]+[kmbKMB]{1}" autofocus [style.left]="toTooltipPosition" [value]="toTooltipValue" (blur)="updateSlider($event, 'to');">

    
  <ion-range-slider
      type="double"
    [prefix]="to.prefix"
    [postfix]="to.postfix"
    [max_postfix]="to.max_postfix"
    force_edges="true"
    values_separator="-"
    prettify_separator=","
    [values]="to.values"
    [from]="formControl?.value.from"
    [to]="formControl?.value.to"
    [min_interval]="to.min_interval"
    [min]="to.min"
    [max]="to.max"
    [step]="to.step"
    (onFinish)="onSliderChange($event)"    
    hide_from_to="true"></ion-range-slider>

    <!-- <button (click)="resetSlider(); $event.preventDefault()">reset</button> -->
</form>
